import {FETCH_FULL_SCHEDULE} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_FULL_SCHEDULE:
            return action.payload;
        default:
            return state;
    }
}